// This is an auto-generated file and cannot be edited
export const environment = 
 {
	"NODE_ENV": "dev",
	"USER_POOL_CLIENT_ID": "2iqisrl45netbepu0ih3paea4r",
	"USER_POOL_ID": "us-east-1_yftnVQ7Q0",
	"IDENTITY_POOL_ID": "us-east-1:34557cbd-db41-436f-b54d-b3266344c926",
	"OAUTH_DOMAIN": "watter-dev.auth.us-east-1.amazoncognito.com",
	"REDIRECT_SIGN_IN_URLS": "https://customer.dev.wattertechnologies.com/home",
	"REDIRECT_SIGN_OUT_URLS": "https://customer.dev.wattertechnologies.com",
	"API_END_POINT": "https://dev.api.wattertechnologies.com/graphql",
	"S3_BUCKET": "296062565941-account-profile-dev",
	"APP_REGION": "us-east-1",
	"REACT_APP_FIREBASE_API_KEY": "AIzaSyDH4q6lF0_L0gMChiC_XcBQXxLUorAszSU",
	"REACT_APP_FIREBASE_AUTH_DOMAIN": "wheater-dev.firebaseapp.com",
	"REACT_APP_FIREBASE_PROJECT_ID": "wheater-dev",
	"REACT_APP_FIREBASE_STORAGE_BUCKET": "wheater-dev.firebasestorage.app",
	"REACT_APP_FIREBASE_MESSAGING_SENDER_ID": "1025575841461",
	"REACT_APP_FIREBASE_APP_ID": "1:1025575841461:web:e8f10924e4c435dc2a18fc",
	"REACT_APP_VAPID_KEY": "BI49vM1KJGFnpNmPt6_CQyU2fQx4Y0gcrsPX0XGkypI09nUpAvp6rFnrS_dSLHHPtHycaFVzyZEhSL1_QTtHMgQ",
	"SOCKET_URL": "wss://dev.api.wattertechnologies.com",
	"APP_VERSION": "1.0.6"
}